import ILDefaultAva from 'assets/icons/default-ava-profile-user.svg'
import ProfilePic from 'components/PMBProfilePic'
import { Card, CardBody, CardText } from 'reactstrap'

const UserInfo = ({ detail }) => {
  return (
    <Card className="w-100 mb-3">
      <CardBody>
        <CardText tag="h6">
          {' '}
          {detail?.orderDetail?.type === 'SELL' ? 'Penjual' : 'Pembeli'}
        </CardText>
        <div className="d-flex align-items-center gap-2">
          <ProfilePic
            imgSrc={
              detail?.sellerDetail?.profileImg ||
              detail?.buyerDetail?.profileImg
            }
            altText={
              detail?.orderDetail?.type === 'SELL'
                ? detail?.sellerDetail?.fullName
                : detail?.buyerDetail?.fullName
            }
            name={
              detail?.orderDetail?.type === 'SELL'
                ? detail?.sellerDetail?.fullName
                : detail?.buyerDetail?.fullName
            }
            avatarSeed={
              detail?.orderDetail?.type === 'SELL'
                ? detail?.sellerDetail?.userId
                : detail?.buyerDetail?.userId
            }
            width={25}
            height={25}
          />
          <span data-testid="order-user-name" className="text-sm fw-semibold">
            {detail?.orderDetail?.type === 'SELL'
              ? detail?.sellerDetail?.fullName
              : detail?.buyerDetail?.fullName}
          </span>
        </div>
      </CardBody>
    </Card>
  )
}

export default UserInfo
